import React, { useState } from "react";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaComments,
} from "react-icons/fa";

const FloatingAction = () => {
  const [open, setOpen] = useState(false);

  const actions = [
    {
      icon: <FaWhatsapp />,
      link: "https://wa.me/9124001120",
      bg: "bg-green-500",
    },
    {
      icon: <FaPhoneAlt />,
      link: "tel:+919124001120",
      bg: "bg-blue-500",
    },
    {
      icon: <FaEnvelope />,
      link: "https://mail.google.com/mail/?view=cm&fs=1&to=sales@mixmasters.in",
      bg: "bg-pink-500",
    },
    {
      icon: <FaMapMarkerAlt />,
      link: "https://www.google.com/maps/dir//Mix+Masters+RMC,+MM+Factory,+Square,+Pitapalli,+Bhubaneswar,+Odisha+752054",
      bg: "bg-yellow-400 text-black",
    },
  ];

  return (
    <div className="fixed bottom-6 right-4 flex flex-col items-center gap-3 z-50">
      {/* Action Buttons */}
      {actions.map((item, index) => (
        <a
          key={index}
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className={`
            w-12 h-12 flex items-center justify-center rounded-full shadow-xl
            text-white text-lg ${item.bg}
            transform transition-all duration-300
            ${
              open
                ? "scale-100 opacity-100 translate-y-0"
                : "scale-0 opacity-0 translate-y-5"
            }
            hover:scale-110
          `}
          style={{ transitionDelay: `${index * 80}ms` }}
        >
          {item.icon}
        </a>
      ))}

      {/* Main FAB Button */}
      <button
        onClick={() => setOpen(!open)}
        className={`
          w-14 h-14 flex items-center justify-center rounded-full shadow-2xl
          text-white text-xl
          bg-gradient-to-r from-purple-500 via-pink-500 to-red-500
          transition-all duration-300 hover:scale-110 animate-bounce   
        `}
      >
        <FaComments />
      </button>
    </div>
  );
};

export default FloatingAction;
